import {Component, Input, OnInit} from '@angular/core';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'ngx-general-chart-stats',
  templateUrl: './general-chart-stats.component.html',
  styleUrls: ['./general-chart-stats.component.scss'],
})
export class GeneralChartStatsComponent implements OnInit {
  @Input() stats: any;

  dependenciasTotales: any = {
    'totales': [],
  };

  dependenciasEntregados: any = {
    'entregados': [],
  };

  countries = [];

  constructor() {
  }

  ngOnInit() {
    this.dependenciasTotales['totales'] = this.stats.map(dependencie => {
      return [dependencie.name, dependencie.total_requirements];
    });

    this.dependenciasEntregados['entregados'] = this.stats.map(dependencie => {
      return [dependencie.name, dependencie.total_delivered];
    });

    this.countries = this.stats.map(dependencie => {
      return {
        name: dependencie.name,
        image: dependencie.logo,
        color: '#00D68F',
      };
    });

    this.drawChart();
  }

  drawChart() {
    const that = this;
    // @ts-ignore
    const chart: any = Highcharts.chart('container', {
      chart: {
        type: 'column',
      },
      title: {
        text: '',
      },
      plotOptions: {
        series: {
          //@ts-ignore
          grouping: false,
          borderWidth: 0,
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        shared: true,
        headerFormat: '<span style="font-size: 15px">{point.point.name}</span><br/>',
        pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
      },
      xAxis: {
        type: 'category',
        labels: {
          useHTML: true,
          animate: true,
          formatter: function() {
            const value = this.value;
            let output;

            that.countries.forEach((country) => {
              if (country.name === value) {
                output = country.image;
              }
            });

            return '<span>' +
                    '<img src="' + output + '" style="width: 35px; height: 35px;"/><br>' +
                  '</span>';
          },
        },
      },
      yAxis: [{
        title: {
          text: '# Requisitos legales',
        },
        showFirstLabel: false,
      }],
      series: [
        //@ts-ignore
        {
          color: 'rgb(158, 159, 163)',
          pointPlacement: -0.2,
          linkedTo: 'main',
          data: this.dependenciasTotales['totales'].slice(),
          name: 'Total',
        },
        //@ts-ignore
        {
          name: 'Entregados',
          id: 'main',
          dataSorting: {
            enabled: true,
            matchByName: true,
          },
          dataLabels: [
            {
              enabled: true,
              inside: true,
              style: {
                fontSize: '16px',
              },
            },
          ],
          data: this.getData(this.dependenciasEntregados['entregados']).slice(),
        }],
      exporting: {
        allowHTML: true,
      },
    });

    const years: any = [2016, 2012];

    years.forEach((year: any) => {
      const btn = document.getElementById(year);
      const thatt = this;
      if (btn){
        btn.addEventListener('click', _ => {
  
          document.querySelectorAll('.buttons button.active').forEach((active) => {
            active.className = '';
          });
          btn.className = 'active';
  
          chart.update({
            title: {
              text: '',
            },
            subtitle: {
              text: 'Comparing to results from Summer Olympics ' + (year - 4) + ' - Source: <ahref="https://en.wikipedia.org/wiki/' + (year) + '_Summer_Olympics_medal_table">Wikipedia</a>',
            },
            series: [{
              name: year - 4,
              data: this.dependenciasTotales[year].slice(),
            }, {
              name: year,
              data: thatt.getData(this.dependenciasEntregados[year]).slice(),
            }],
          }, true, false, {
            duration: 800,
          });
        });
      }
    });
  }

  getData(data) {
    return data.map((country, i) => {
      return {
        name: country[0],
        y: country[1],
        color: this.countries[i].color,
      };
    });
  }

}
